import { useCallback } from "react";
import { useNotificationContext } from "@entrilia/shared/contexts/NotificationContext.ts";
import { useAppDispatch } from "../../../../store/hooks/useAppDispatch.ts";
import { createFinancialStatementAction } from "../../../../store/utils/storeUtils.ts";
import type { AxisOutcome } from "../utils/statementColumns.ts";

const useAxisOutcomeHandler = (): ((outcome: AxisOutcome) => void) => {
  const dispatch = useAppDispatch();
  const { sendNotification } = useNotificationContext();

  return useCallback(
    (outcome: AxisOutcome) => {
      if (outcome.kind === "refuse") {
        sendNotification(outcome.message);
        return;
      }
      dispatch(createFinancialStatementAction("addAxis", outcome.axis));
    },
    [dispatch, sendNotification]
  );
};

export default useAxisOutcomeHandler;
